module.exports = __webpack_public_path__ + "img/icon.fb.1c5364f5.svg";